import React, { useEffect, useState } from 'react';
import { IconButton, ButtonBase } from '@mui/material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import { useMutation } from '@apollo/client';
import styles from './EditStatusModal.module.scss';
import RemoveUserModal from './RemoveUserModal';
import { UPDATE_USER_STATUS } from '../../../../../api';

const statuses = [
  { value: 'deleted', label: 'Deleted' },
  { value: 'blocked', label: 'Blocked' },
  { value: 'not_blocked', label: 'Not Blocked' },
  { value: 'recovered', label: 'Recover' },
];
const EditStatusModal = ({
  open,
  handleClose,
  userFullName,
  userId,
  userStatus,
  setAdminUsersList,
}) => {
  const [removeUserModal, setRemoveUserModal] = useState(false);
  const [checkedStatus, setCheckedStatus] = useState('');
  const [updateUserStatus] = useMutation(UPDATE_USER_STATUS, {
    variables: { input: {} },
  });

  useEffect(() => {
    setCheckedStatus(userStatus);
  }, [open]);

  const handleChangeStatus = async (status) => {
    try {
      await updateUserStatus({
        variables: {
          input: {
            user_id: userId,
            status: status,
          },
        },
      }).then(() => {
        setAdminUsersList((current) =>
          current.map((item) => {
            if (item.id === userId) {
              return { ...item, status: status === 'recovered' ? 'not_blocked' : status };
            }
            return item;
          })
        );
        setRemoveUserModal(false);
        handleClose();
      });
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <>
      <Modal
        BackdropProps={{
          style: {
            backgroundColor: 'white',
            backdropFilter: 'blur(14px)',
            background: 'rgba(250, 250, 250, 0.8)',
          },
        }}
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box className={styles.editStatusModal}>
          <Box className={styles.modalTitle}>
            Do you want to change a user status?
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 30,
                top: 20,
                color: (theme) => theme.palette.grey[900],
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box className={styles.modalContent}>
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                value={checkedStatus}
                name="radio-buttons-group"
                onChange={(e) => e.target.value !== 'deleted' && setCheckedStatus(e.target.value)}
              >
                {statuses.map((item) =>
                  (userStatus !== 'deleted' && item.value !== 'recovered') ||
                  userStatus === 'deleted' ? (
                    <FormControlLabel
                      onChange={() => {
                        if (item.value === 'deleted') {
                          setRemoveUserModal(true);
                        }
                      }}
                      value={item.value}
                      control={<Radio />}
                      label={
                        <Typography
                          className={[
                            styles.statusName,
                            userStatus === 'deleted' &&
                              item.value === 'deleted' &&
                              styles.disabledStatusName,
                          ]}
                        >
                          {item.label}
                        </Typography>
                      }
                      disabled={userStatus === 'deleted' && item.value === 'deleted'}
                    />
                  ) : null
                )}
              </RadioGroup>
            </FormControl>
          </Box>
          <Box className={styles.modalActions}>
            <ButtonBase
              className={styles.leftButton}
              onClick={() => {
                setCheckedStatus('');
                handleClose();
              }}
            >
              CANCEL
            </ButtonBase>
            <ButtonBase
              className={styles.rightButton}
              onClick={() => handleChangeStatus(checkedStatus)}
            >
              CONFIRM
            </ButtonBase>
          </Box>
        </Box>
      </Modal>
      <RemoveUserModal
        userId={userId}
        deleteUser={() => handleChangeStatus('deleted')}
        userFullName={userFullName}
        open={removeUserModal}
        handleClose={() => {
          setRemoveUserModal(false);
        }}
      />
    </>
  );
};

export default EditStatusModal;
